<template>
  <div class="debrief">
    <div class="top">
      <div class="back" @click="back" >
        <i class="el-icon-arrow-left" /> 返回
      </div>
      <div class="path">
        <i class="el-icon-location" /> 首页-典型问题汇报
      </div>
    </div>

    <div class="debriefcont">
      <el-tabs v-model="activeName">
        <el-tab-pane label="日报" name="day">
          <dayreport />
        </el-tab-pane>
        <el-tab-pane label="周报" name="week">
          <weekreport />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>


<script>
import dayreport from "./dayreport";
import weekreport from "./weekreport";
export default {
  components: {
    dayreport,
    weekreport,
  },
  data() {
    return {
      activeName: "day"
    };
  },
  methods: {
    back() {
      this.$router.push({ name: "HomePage" });
    }
  }
};
</script>

<style lang="less" scoped>
.debrief {
  background-color: #f5f6fd;
  padding: 17px 19px;
  height: calc(100vh - 100px);
  .top {
    height: 49px;
    background: white;
    font-size: 14px;
    font-family: PingFangSC, PingFangSC-Regular;
    color: #99a9ba;
    overflow: hidden;
    position: relative;
    border-radius: 4px;
    box-shadow: 0px 6px 14px 0px rgba(127, 170, 217, 0.12);
    .back {
      margin-left: 19px;
      margin-top: 15px;
      display: inline-block;
      cursor: pointer;
    }
    .path {
      margin-left: 19px;
      margin-top: 15px;
      display: inline-block;
    }
  }
  .debriefcont {
    height: calc(100vh - 195px);
    margin-top: 9px;
    background: white;
    font-size: 12px;
    font-family: PingFangSC, PingFangSC-Regular;
    overflow: hidden;
    position: relative;
    border-radius: 4px;
    box-shadow: 0px 6px 14px 0px rgba(127, 170, 217, 0.12);
    padding: 18px 20px;
  }
}
</style>
